import util from '@/libs/util'

// 菜单 顶栏
// export const menuHeader = []

// 菜单 侧边栏
// export const menuAside = []

/**
 * 将数据源处理为菜单树
 * @param arr
 * @returns {{header: Array, aside: Array}}
 */
function getMenuData(arr) {
  let tree = { header: [], aside: [] }
  arr.forEach(value => {
    // if (!value.is_navi || !value.status) {
    //   return
    // }

    // 储存顶部(父节点)数据
    let arrElem = {
      path: value.path,
      title: value.title,
      icon: value.icon,
      remark: value.remark
    }

    // 只将父id是0的菜单置顶
    if (value.parentId === 0) {
      tree.header.push({ ...arrElem })
    }
    // 处理子节点数据
    arrElem['menuId'] = value.menuId
    arrElem['parentId'] = value.parentId
    // tree.aside.push(arrElem)
  })
  tree.aside = arr
  // tree.aside = util.formatDataToTree(tree.aside)
  return tree
}

export default {
  install(vm, source) {
    const menu = getMenuData(source)
    // 设置头部主菜单栏
    vm.commit('d2admin/menu/headerSet', menu.header)
    // 设置左侧辅助菜单栏
    vm.commit('d2admin/menu/asideSet', menu.aside)
    // 设置搜索菜单栏项目
    // vm.commit('d2admin/search/init', menu.aside)
  }
}
